import { combineReducers } from "redux";
import { Consult } from "../../types";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import { FETCH_CONSULT_REQUEST } from "./constants";
import { Action } from "./type";

function item(state: Partial<Consult> = {}, action: Action): Partial<Consult> {
  switch (action.type) {
    case getSuccessActionType(FETCH_CONSULT_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state = false, action: Action) {
  switch (action.type) {
    case FETCH_CONSULT_REQUEST:
      return true;

    case getSuccessActionType(FETCH_CONSULT_REQUEST):
    case getFailureActionType(FETCH_CONSULT_REQUEST):
      return false;

    default:
      return state;
  }
}

export const consult = combineReducers({ item, isFetching });
